import { Component } from "react";
import MDSpinner from "react-md-spinner";
import logoSpinner from "./../../images/logoSpinner.svg";

export default class TalaeraSpinner extends Component {
  render() {
    if (this.props.className || this.props.color || this.props.size || this.props.style) {
      const className = this.props.className ? this.props.className : "spinner";

      return (
        <MDSpinner
          singleColor={this.props.color ? this.props.color : "#01BCD4"}
          size={this.props.size ? this.props.size : 40}
          className={className}
          style={this.props.style}
        />
      );
    } else {
      return (
        <img src={logoSpinner} alt="logo spinner" style={{ width: 50, marginTop: 20 }} />
      );
    }
  }
}
